import { useState } from "react";
import { router } from "@inertiajs/react";
import Header from "../Component/Header";

export default function Create({ walletLocks = [] }) {
    const [form, setForm] = useState({
        pay_code: "",
        pay_total: "",
        pay_method: 0,
        wallet_lock_id: "",
    });
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const setField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const submit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setErrors({});

        try {
            await window.axios.post(
                "/panel/payments",
                {
                    pay_code: form.pay_code,
                    pay_total: form.pay_total,
                    pay_method: Number(form.pay_method),
                    wallet_lock_id: form.wallet_lock_id === "" ? null : Number(form.wallet_lock_id),
                },
                { headers: { Accept: "application/json" } }
            );

            router.visit("/panel/payments");
        } catch (error) {
            setErrors(error?.response?.data?.errors ?? {});
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Header />
            <main id="content" className="pb-14 sm:pb-16">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto">
                    <div className="py-2 sm:pb-0 sm:pt-5 space-y-5">
                        <p className="text-sm text-muted-foreground-1">Payment</p>

                        <form onSubmit={submit} className="grid grid-cols-1 lg:grid-cols-6 gap-5">
                            <div className="lg:col-span-4 space-y-4">
                                <div className="flex flex-col bg-card border border-card-line overflow-hidden rounded-xl shadow-2xs">
                                    <div className="py-3 px-5 border-b border-card-header">
                                        <h2 className="font-semibold text-foreground">Create Payment</h2>
                                    </div>
                                    <div className="p-5 space-y-4">
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Payment Code</label>
                                            <input
                                                type="text"
                                                value={form.pay_code}
                                                onChange={(e) => setField("pay_code", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                                placeholder="e.g. PAY-0001"
                                            />
                                            {errors.pay_code && <p className="mt-1 text-xs text-red-600">{errors.pay_code}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Total</label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={form.pay_total}
                                                onChange={(e) => setField("pay_total", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                                placeholder="0.00"
                                            />
                                            {errors.pay_total && <p className="mt-1 text-xs text-red-600">{errors.pay_total}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Method</label>
                                            <select
                                                value={form.pay_method}
                                                onChange={(e) => setField("pay_method", Number(e.target.value))}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            >
                                                <option value={0}>Cash</option>
                                                <option value={1}>Transfer</option>
                                            </select>
                                            {errors.pay_method && <p className="mt-1 text-xs text-red-600">{errors.pay_method}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">Wallet Lock (optional)</label>
                                            <select
                                                value={form.wallet_lock_id}
                                                onChange={(e) => setField("wallet_lock_id", e.target.value)}
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground"
                                            >
                                                <option value="">None</option>
                                                {walletLocks.map((walletLock) => (
                                                    <option key={walletLock.wallet_lock_id} value={walletLock.wallet_lock_id}>
                                                        #{walletLock.wallet_lock_id}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.wallet_lock_id && <p className="mt-1 text-xs text-red-600">{errors.wallet_lock_id}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={() => router.visit("/panel/payments")}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-layer border border-layer-line text-layer-foreground"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={submitting}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-primary border border-primary-line text-primary-foreground disabled:opacity-50"
                                    >
                                        {submitting ? "Saving..." : "Save Payment"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
}
